import { SectionBackground } from '@components/SectionBackground';
import type * as React from 'react';
import { useFragment } from 'react-relay';
import SectionNavigation from '../../../sectionNavigation';
import { pageSectionClassName } from '../PageSectionsStyles';
import { homeFundInfoserviceSectionFragment } from './HomeFundInfoserviceSection.relay';
import type { HomeFundInfoserviceSectionPropsType } from './types';

const HomeFundInfoserviceSection: React.FC<HomeFundInfoserviceSectionPropsType> = (props: HomeFundInfoserviceSectionPropsType) => {
  const pageSection = useFragment(homeFundInfoserviceSectionFragment, props.pageSection);

  return (
    <div className={pageSectionClassName}>
      <SectionBackground anchorName={pageSection.anchorName} url={process.env.HOST + pageSection.titleImageUrl} backgroundUrl={process.env.HOST + pageSection.titleImageBackgroundUrl} />

      <div className="section-content-wrapper Home-container">
        <div className="text-nav-wrapper">
          <div className="section-text">
            <h1 className="Base-title">{pageSection.title}</h1>
            <p>{pageSection.text}</p>
            <div className="Home-login">
              <a
                href={pageSection.loginLink}
                className="inline-flex items-center justify-center cursor-pointer rounded-[30px] border border-black bg-white px-10 py-2.5 text-[15px] font-normal uppercase tracking-wide text-accent no-underline outline-none my-2.5"
              >
                {pageSection.loginText}
              </a>
              <a
                href={pageSection.registrationLink}
                className="inline-flex items-center justify-center cursor-pointer rounded-[30px] border border-black bg-white px-10 py-2.5 text-[15px] font-normal uppercase tracking-wide text-accent no-underline outline-none my-2.5"
              >
                {pageSection.registrationText}
              </a>
            </div>
          </div>
          <SectionNavigation sectionNavigation={props.sectionNavigation} activeIndex={props.index} />
        </div>
      </div>
    </div>
  );
};

export { HomeFundInfoserviceSection };
